import React from 'react';
import styles from './SaveItineraryModal.module.css';
import { useTranslation } from 'react-i18next';
import { useMapDisplayContext } from '../MapDisplayContext';
import { MapModal } from '../Components/MapModal/MapModal';
import { AnimatedButton } from '../AnimatedButton';

interface SaveItineraryModalProps {
  onClose: () => void;
  onSave: (name: string) => void;
}

export const SaveItineraryModal: React.FC<SaveItineraryModalProps> = ({ onClose, onSave }) => {
  const { newItinerary } = useMapDisplayContext();
  const { t } = useTranslation();
  const [name, setName] = React.useState(newItinerary?.title || '');

  return (
    <MapModal onClose={onClose}>
      <div className={styles.content}>
        <h2 className={styles.title}>{t('Save Your Itinerary')}</h2>
        <div className={styles.inputContainer}>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t('Itinerary 1')}
            className={styles.input}
            autoFocus
          />
        </div>
        <div className={styles.buttonContainer}>
          <AnimatedButton
            className={styles.saveButton}
            onClick={() => onSave(name)}
            clickedClassName={styles.clicked}
          >
            {t('Save')}
          </AnimatedButton>
          <AnimatedButton
            className={styles.backButton}
            onClick={onClose}
            clickedClassName={styles.clicked}
          >
            {t('Back')}
          </AnimatedButton>
        </div>
      </div>
    </MapModal>
  );
};
